import useDocumentTitle from "src/hooks/useDocumentTitle";

export default Page;

function Page({ title, children, withoutPrefix }) {
  useDocumentTitle(withoutPrefix ? title : `MileIQ - ${title}`);

  return children;
}
